import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Aside = styled.aside`
  min-height: 100vh;
  padding-inline: 24px;
  box-sizing: border-box;
  background-color: var(--section-snow-background-color, var(--snow));

  @media (max-width: 1030px) {
    min-height: unset;
    padding-inline: 16px;
  }
`;

export const BillingTitle = styled(Typography.Title)`
  margin-left: 16px;
`;
